import GranteeForm from './GranteeForm.jsx';
import { mapIndexed } from '@@serverHelpers/index.mjs';

const GranteesForm = ({
  regimeObligatoire,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  fields,
  selectedTab,
  professionalSituations
}) => {
  return (
    <div className="w-full">
      {mapIndexed(
        (field, index) => (
          <div key={field.id}>
            <GranteeForm
              field={field}
              index={index}
              regimeObligatoire={regimeObligatoire}
              selectedTab={selectedTab}
              getMiddleText={getMiddleText}
              getMiddleBoolean={getMiddleBoolean}
              getMiddleNumber={getMiddleNumber}
              professionalSituations={professionalSituations}
            />
          </div>
        ),
        fields
      )}
    </div>
  );
};

export default GranteesForm;
